import styles from './ProviderLogo.scss';

export const PROVIDER_LOGO_MAPPING = {
  '1x2 Gaming': styles.oneOnTwoGaming,
  '4ThePlayer': styles.forThePlayer,
  '7 Deuce Gaming': styles.sevenDeuceGaming,
  AGS: styles.ags,
  amusnet: styles.amusnet,
  authenticgaming: styles.authenticgaming,
  Blueprint: styles.bluePrintGaming,
  Bragg: styles.bragg,
  BTG: styles.btg,
  CapeCod: styles.capeCod,
  Cayetano: styles.starsStudios,
  'Core Gaming': styles.starsStudios,
  DWG: styles.dwg,
  DGC: styles.dgc,
  EGT: styles.egt,
  ELK: styles.elk,
  Everi: styles.everi,
  Evolution: styles.evolutionGaming,
  Fantasma: styles.fantasma,
  flutterstudios: styles.starsStudios,
  'Games Global': styles.gamesGlobal,
  Gamevy: styles.gamevy,
  'Gaming Corps': styles.gamingCorps,
  'Gaming Realms': styles.gamingRealms,
  GiocaOnline: styles.giocaOnline,
  gol_games: styles.golGames,
  Greentube: styles.greentube,
  'Hacksaw Gaming': styles.hacksawGaming,
  High5: styles.high5Games,
  IGT: styles.igt,
  Inspired: styles.inspiredGaming,
  iSoftBet: styles.iSoftBet,
  'Instant Win Gaming': styles.instantWinGaming,
  Ino: styles.ino,
  Ingenuity: styles.starsStudios,
  Kalamba: styles.kalamba,
  Konami: styles.konami,
  Leander: styles.leander,
  'Light And Wonder': styles.lightAndWonder,
  'Lightning Box': styles.lightningBox,
  MGA: styles.mgaGames,
  NetEnt: styles.netent,
  'Nolimit City': styles.nolimitSity,
  Octoplay: styles.octoplay,
  ODDSworks: styles.oddWorks,
  OnAir: styles.onAir,
  PlayNGo: styles.playNGo,
  Playson: styles.playson,
  Playtech: styles.playtech,
  Playzido: styles.playzido,
  Pragmatic: styles.pragmaticPlay,
  Push: styles.pushGaming,
  Quickspin: styles.quickspin,
  'RAW Gaming': styles.rawIgaming,
  'Red Rake': styles.redRake,
  'Red Tiger': styles.redTiger,
  'Reel Play': styles.reelPlay,
  'Relax Gaming': styles.relaxGaming,
  RTG: styles.rtg,
  RubyPlay: styles.rubyPlay,
  'SG Digital': styles.sgDigital,
  Skywind: styles.skywind,
  Spinomenal: styles.spinomenal,
  Spribe: styles.spribe,
  Stakelogic: styles.stakeLogic,
  Synot: styles.synot,
  subtract: styles.elkStudios,
  Thunderkick: styles.thunderkick,
  union: styles.union,
  Wazdan: styles.wazdan,
  WHS: styles.whs,
  WMG: styles.wmg,
  Yggdrasil: styles.yggdrasil,
  'Card and Table': styles.cardAndTable,
  PYRSoftware: styles.pyrsoftware,
  Onseo: styles.starsStudios,
  Premium: styles.starsStudios,
  'Video Poker': styles.videoPoker
};
